import { APPLICATION_ROUTES } from '@philips-emr/hpms-stipulator-commons';
import { applicationModuleRegistry } from '@philips-emr/tws-foundation';

export default function registerInformacaoContratual(): void {

  const modules = [{
    entry: 'dossie-contrato',
    id: 'dossie-contrato',
    name: '$expression.$1032298',
    route: APPLICATION_ROUTES.DOSSIE_CONTRATO,
    closeable: true,
  }, {
    entry: 'dossie-beneficiario',
    id: 'dossie-beneficiario',
    name: 'stipulator.dossie-do-beneficiario',
    route: APPLICATION_ROUTES.DOSSIE_BENEFICIARIO,
    closeable: true,
  }];

  applicationModuleRegistry.registerGroup({
    entry: 'informacao-contratual',
    id: 'informacao-contratual',
    name: 'stipulator.informacoes-contratuais',
    modules,
    order: 2,
    closeable: true,
  });
}
